import { FETCH_DIRECTORY_PRODUCTS, FETCHED_DIRECTORY_PRODUCTS, SELECT_DIRECTORY_PRODUCT, SEARCH_DIRECTORY_PRODUCTS, ANYWHERE_PARAM_PRODUCT, START_WITH_PARAM, SELECT_ALL_PRODUCTS, SELECT_STATE_ALL_PRODUCTS, SELECT_STATE_PART_PRODUCTS, CLEAR_ALL_SELECTION_PRODUCTS } from './DirectoryProductsActions'

const directoryProductsReducer = (state = { searchParameter: "", directoryProducts: [], isFetching: false, isResultFetched: false, count: 0, currentPage: 0, searchAnywhereParam: "", startWithParam: "", isFetchingProductDetails: false, selectedProductDetails: null, selectionState: SELECT_STATE_PART_PRODUCTS, selectedRows: [] }, action) => {

    switch (action.type) {
        case FETCH_DIRECTORY_PRODUCTS:
            return {
                ...state,
                isFetching: true,
                isResultFetched: false,
                currentPage: action.first ? 0 : (state.currentPage + 1),
                directoryProducts: action.first ? [] : state.directoryProducts,
                selectedProductDetails: null,
                activeLangCodeOfPages: action.first ? action.activeLangCode : state.activeLangCodeOfPages
            }
        case FETCHED_DIRECTORY_PRODUCTS:

            let newDirectoryProducts = state.currentPage === 0 ? action.directoryProducts.data.map(x => ({ ...x, isMatchSearch: true })) : [...state.directoryProducts, ...action.directoryProducts.data.map(x => ({ ...x, isMatchSearch: true }))]
            
            return {
                ...state,
                isFetching: false,
                isResultFetched: true,
                searchParameter: "",
                directoryProducts: newDirectoryProducts,
                count: action.directoryProducts.paging.count,
                selectedRows: state.selectionState === SELECT_STATE_ALL_PRODUCTS ? newDirectoryProducts : state.selectedRows
            }
        case SEARCH_DIRECTORY_PRODUCTS:
            return {
                ...state,
                searchParameter: action.searchParameter
            }
        case SELECT_DIRECTORY_PRODUCT:
            let newSelectedRows = state.selectedRows.filter(x => x.id === action.directoryProduct.id).length > 0 ? state.selectedRows.filter(x => x.id !== action.directoryProduct.id) : [...state.selectedRows, action.directoryProduct]

            return {
                ...state,
                selectedRows: newSelectedRows,
                selectedProductDetails: null,
                selectionState: SELECT_STATE_PART_PRODUCTS
            }
        case ANYWHERE_PARAM_PRODUCT:
            return {
                ...state,
                searchAnywhereParam: action.searchAnywhereParam
            }
        case START_WITH_PARAM:
            return {
                ...state,
                startWithParam: action.startWithParam
            }
        case SELECT_ALL_PRODUCTS:
            return {
                ...state,
                selectionState: state.selectedRows.length > 0 ? SELECT_STATE_PART_PRODUCTS : SELECT_STATE_ALL_PRODUCTS,
                selectedRows: state.selectedRows.length > 0 ? [] : state.directoryProducts
            }
        case CLEAR_ALL_SELECTION_PRODUCTS:
            return {
                ...state,
                selectionState: SELECT_STATE_PART_PRODUCTS,
                selectedRows: []
            }  
        default:
            return state;
    }
}

export default directoryProductsReducer;


// WEBPACK FOOTER //
// ./src/features/modules/directory-of-manufactory/directory-products/DirectoryProductsReducer.js